import axios from "axios"
import { couponValidateStatusTypeMap } from '@/views/config/coupon/helper/constant';

export const validateAssignLicense = async (data) => {
  try {
    const { result } = await axios.post('/opc/validate/assign/info', data);

    if (result?.status === couponValidateStatusTypeMap.FAIL) {
      return Promise.reject({ ...result, errorMessage: result?.message });
    }

    return Promise.resolve(result);
  } catch (e) {
    return Promise.reject({ errorMessage: e?.message });
  }
};
